import { Link } from 'react-router-dom';
import { AvatarMenu } from './AvatarMenu';

// Topbar mirrors the demo's `.topbar` + `.brand-mark`:
//   - navy-900 background, white text
//   - 76px tall on desktop (16px less on mobile to keep airy proportions)
//   - 48px brand logo + "BUSY" white / "BARBER" gold-400 wordmark in Anton 28px
//   - flashing "BETA" badge dead-center while the app is in early access
//   - avatar menu pushed to the far right
export function TopBar() {
  return (
    <header className="sticky top-0 z-30 bg-navy-900 text-white border-b border-white/10 shadow-sm">
      <div className="h-16 md:h-[76px] px-4 md:px-6 max-w-page mx-auto flex items-center gap-3 relative">
        <Link to="/today" className="flex items-center gap-3 shrink-0 group">
          <span className="w-10 h-10 md:w-12 md:h-12 rounded-[11px] grid place-items-center overflow-hidden">
            <img
              src="/assets/busy-icon.png"
              alt=""
              className="w-full h-full object-cover"
            />
          </span>
          <span className="font-display tracking-[0.04em] leading-none text-[22px] md:text-[28px] text-white group-hover:opacity-90 transition-opacity">
            BUSY <span className="text-gold-400">BARBER</span>
          </span>
        </Link>

        {/* Center-pinned BETA badge. Absolutely positioned so it sits in
            the visual center of the bar regardless of how wide the brand
            mark / avatar are. Pointer-events-none so it doesn't block
            clicks on whatever's underneath. Pulsing gold draws the eye
            without being obnoxious. */}
        <div
          aria-hidden
          className="pointer-events-none absolute inset-y-0 left-1/2 -translate-x-1/2 flex items-center"
        >
          {/* paddingLeft = letter-spacing compensates for the trailing
              phantom edge created by tracking-* (browsers add the spacing
              after every letter including the last). Without this the
              visible "BETA" sits ~3px left of geometric center because
              the trailing space widens the box on the right. Adding
              matching space on the left re-balances the visible text.
              Same fix used on every tracked pill / centered-tracked text
              elsewhere — text-indent doesn't apply reliably to inline
              spans or flex items, padding-left always does. */}
          <span
            className="font-display tracking-[0.22em] text-gold-400 text-[14px] md:text-[16px] animate-[betaPulse_1.6s_ease-in-out_infinite] drop-shadow-[0_0_8px_rgba(232,198,106,0.45)]"
            style={{ paddingLeft: '0.22em' }}
          >
            BETA
          </span>
        </div>

        <div className="ml-auto">
          <AvatarMenu />
        </div>
      </div>
      <style>{`
        @keyframes betaPulse {
          0%, 100% { opacity: 1; transform: scale(1); }
          50%      { opacity: 0.55; transform: scale(0.96); }
        }
      `}</style>
    </header>
  );
}
